<script>
export default {
    name: 'Paginator',

    props: {
        model: Object,
        programmatic: Boolean,
        limit: {
            type: Number,
            default: 5,
        },
    },

    computed: {
        component() {
            return this.programmatic ? 'button' : 'router-link'
        },
        pages() {
            let arr = []
            let limit = Math.round((this.$store.getters[`smDevice`] ? 3 : this.limit) / 2)
            let residue = (this.$store.getters[`smDevice`] ? 3 : this.limit) % 2
            for (let i = 0; i < this.lastPage; ++i) {
                arr.push(i + 1)
            }
            if (this.currentPage > this.lastPage - limit) {
                arr = arr.slice(this.lastPage - limit, this.lastPage)
            } else if (this.currentPage - limit < 1) {
                arr = arr.slice(0, limit)
            } else {
                const first = this.currentPage < limit ? 0 : this.currentPage - limit
                arr = arr.slice(first, this.currentPage + limit - residue)
            }
            return arr
        },

        total() {
            return this.model?.total || 0
        },
        from() {
            return this.currentPage * this.model?._itemsPerPage - this.model?._itemsPerPage + 1 || 1
        },
        to() {
            return this.currentPage === this.lastPage
                ? this.total
                : this.currentPage * this.model?._itemsPerPage || 0
        },
        currentPage() {
            return this.model?._currentPage
        },
        lastPage() {
            return this.model?._lastPage
        },
    },

    methods: {
        step(page) {
            if (this.programmatic) this.$emit('step', page)
        },
    },
}
</script>

<template lang="pug">
.row(v-if="model")
    .col.col-lg-8.flex-center.justify-content-md-start
        .d-flex.align-items-center(v-if="lastPage > 1")
            component.btn.btn-link.btn-icon.btn-sm.ml-2(
                :is="programmatic || 1 === currentPage ? 'button' : component"
                :disabled="1 === currentPage"
                :to="programmatic || 1 === currentPage ? undefined :  {params: {page: 1}, query: $route.query}"
                :replace="programmatic || 1 === currentPage ? undefined : true"
                @click="step(1)"
            )
                icon(icon="fa-solid fa-angles-left")
            component.btn.btn-link.btn-icon.btn-sm.mr-2(
                :is="programmatic || 1 === currentPage ? 'button' : component"
                :disabled= "1 === currentPage"
                :to="programmatic || 1 === currentPage ? undefined : {params: {page: currentPage - 1}, query: $route.query}"
                :replace="programmatic || 1 === currentPage ? undefined : true"
                @click="step(currentPage - 1)"
            )
                icon(icon="fa-solid fa-angle-left")
            component.btn.btn-transparent.btn-icon.border-0.btn-sm.font-weight-bold.mx-2(
                :is="component"
                v-for="page in pages"
                :key="page"
                :to="programmatic ? undefined : {params: {page: page}, query: $route.query}"
                :active-class="programmatic ? undefined : 'text-primary'"
                :class="programmatic && page === currentPage ? 'text-primary' : undefined"
                :replace="programmatic ? undefined : true"
                @click="step(page)"
            ) {{page}}
            component.btn.btn-link.btn-icon.btn-sm.ml-2(
                :is="programmatic || lastPage === currentPage ? 'button' : component"
                :disabled="lastPage === currentPage"
                :to="programmatic || lastPage === currentPage ? undefined : {params: {page: currentPage + 1}, query: $route.query}"
                :replace="programmatic || lastPage === currentPage ? undefined : true"
                @click="step(currentPage + 1)"
            )
                icon(icon="fa-solid fa-angle-right")
            component.btn.btn-link.btn-icon.btn-sm.ml-2(
                :is="programmatic || lastPage === currentPage ? 'button' : component"
                :disabled="lastPage === currentPage"
                :to="programmatic || lastPage === currentPage ? undefined : {params: {page: lastPage}, query: $route.query}"
                :replace="programmatic || lastPage === currentPage ? undefined : true"
                @click="step(lastPage)"
            )
                icon(icon="fa-solid fa-angles-right")
    .col-12.col-lg-4.d-flex.align-items-center
        .ml-auto {{ $t('base.paginator_showing', {to: to, from: from, total: total})}}
</template>
